import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ModalNuevaPlaneacion } from "./components/modalNuevo";
import { VisulizadorActivo } from "./components/visualizadorActivo";
import {
  GetPlanActivo,
  UpdatePrioridad,
  UpdatePrioridadIndividual,
} from "../../../hooks/planProductivo";
import { useLoading } from "../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";
import { ModalAgregarItem } from "./components/agregarItem";
import { ModalEditItems } from "./components/editItems";

export const PlaneacionIndex = () => {
  const { getPlanActivoMutation } = GetPlanActivo();
  const { updatePrioridadMutation } = UpdatePrioridad();
  const { updatePrioridadIndividualMutation } = UpdatePrioridadIndividual();
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const [openNuevo, setOpenNuevo] = useState(false);
  const [openNuevoItem, setOpenNuevoItem] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [itemsEdit, setItemsEdit] = useState([]);
  const [almaSelectedEdit, setAlmaSelectedEdit] = useState(null);
  const [planActivo, setPlanActivo] = useState(null);
  const [reorderedItems, setReorderedItems] = useState(null);
  const [newPriority, setNewPriority] = useState(null);
  const [reorderSend, setReorderSend] = useState(false);
  const [lastPriority, setLastPriority] = useState(0);

  useEffect(() => {
    getPlanActivo();
  }, []);

  const getPlanActivo = () => {
    getPlanActivoMutation(
      {},
      {
        onSuccess: (data) => {
          console.log("Plan activo obtenido:", data.data);
          const plan = data.data;
          plan.plan_productivo_almacenes.map((alma) => {
            if (alma?.almacenes?.alma_secuencial) {
              alma.plan_productivo_almacen_items =
                alma.plan_productivo_almacen_items.sort(
                  (a, b) => a.pp_alma_item_prioridad - b.pp_alma_item_prioridad,
                );
            }
          });
          setPlanActivo(plan);
        },
        onError: (error) => {
          enqueueSnackbar("Error al obtener la planeación", {
            autoHideDuration: 2000,
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        },
        onSettled: () => {
          setAppLoading(false);
        },
      },
    );
  };
  const updatePrioridad = () => {
    setAppLoading(true);
    updatePrioridadMutation(reorderSend, {
      onSuccess: (data) => {
        enqueueSnackbar("Prioridades actualizadas", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        enqueueSnackbar("Error al actualizar prioridades", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setReorderSend(false);
        setReorderedItems(null);
        getPlanActivo();
        setAppLoading(false);
      },
    });
  };

  const reorderPriorities = (items, itemId, newPriority) => {
    // Clonamos para no mutar el estado original
    console.log("Reordenando prioridades:", { items, itemId, newPriority });
    let updated = items.map((item) => ({ ...item }));

    // Encontramos el item que queremos cambiar
    const targetIndex = updated.findIndex((i) => i.pp_alma_item_id === itemId);
    const oldPriority = updated[targetIndex].pp_alma_item_prioridad;

    if (oldPriority === newPriority) return items; // Sin cambios

    updated.forEach((item) => {
      if (item.pp_alma_item_id === itemId) {
        // Al item seleccionado le asignamos la nueva prioridad
        item.pp_alma_item_prioridad = newPriority;
      } else {
        // A los demás los "recorremos" según la dirección del cambio
        if (newPriority < oldPriority) {
          // Subió de prioridad: los que estaban entre newPriority y oldPriority suben uno
          if (
            item.pp_alma_item_prioridad >= newPriority &&
            item.pp_alma_item_prioridad < oldPriority
          ) {
            item.pp_alma_item_prioridad += 1;
          }
        } else {
          // Bajó de prioridad: los que estaban entre oldPriority y newPriority bajan uno
          if (
            item.pp_alma_item_prioridad > oldPriority &&
            item.pp_alma_item_prioridad <= newPriority
          ) {
            item.pp_alma_item_prioridad -= 1;
          }
        }
      }
    });

    // Ordenamos la lista por prioridad para que se vea limpio
    return updated.sort(
      (a, b) => a.pp_alma_item_prioridad - b.pp_alma_item_prioridad,
    );
  };

  const handlePriorityChange = (itemId, newPriority) => {
    const plan = { ...planActivo };
    const index = plan.plan_productivo_almacenes.findIndex(
      (pp) => pp.pp_alma_id === reorderedItems,
    );
    if (index === -1) return;
    const items =
      plan.plan_productivo_almacenes[index]?.plan_productivo_almacen_items ||
      [];
    const reordered = reorderPriorities(items, itemId, Number(newPriority));
    plan.plan_productivo_almacenes[index].plan_productivo_almacen_items =
      reordered;
    const send = reordered.map((item) => ({
      pp_alma_item_id: item.pp_alma_item_id,
      pp_alma_item_prioridad: item.pp_alma_item_prioridad,
    }));
    setReorderSend(send);
    setPlanActivo(plan);
    console.log("Lista reordenada:", reordered);
  };
  const handleNuevoItem = (almaId) => {
    const planes = planActivo.plan_productivo_almacenes;
    const planAlma = planes.find((p) => p.pp_alma_id === almaId);
    if (!planAlma) return;
    const lastPriority = planAlma.plan_productivo_almacen_items.reduce(
      (max, item) =>
        item.pp_alma_item_prioridad > max ? item.pp_alma_item_prioridad : max,
      0,
    );
    console.log("Última prioridad encontrada:", lastPriority);
    setLastPriority(lastPriority);
    setNewPriority(almaId);
    setOpenNuevoItem(true);
  };
  const updatePrioridadIndividual = (itemId, done) => {
    setAppLoading(true);
    const body = {
      pp_alma_item_done: done ? 1 : 0,
    };
    updatePrioridadIndividualMutation(
      { itemId, body },
      {
        onSuccess: (data) => {
          enqueueSnackbar("Estado del item actualizado", {
            autoHideDuration: 2000,
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        },
        onError: (error) => {
          enqueueSnackbar("Error al actualizar el estado del item", {
            autoHideDuration: 2000,
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        },
        onSettled: () => {
          setAppLoading(false);
          getPlanActivo();
        },
      },
    );
  };

  const handleOpenEditSec = (alma) => {
    setItemsEdit(alma.plan_productivo_almacen_items);
    setAlmaSelectedEdit(alma);
    setOpenEdit(true);
  }

  const handleClose = () => {
    getPlanActivo();
    setTimeout(() => {
      setOpenNuevo(false);
    }, 500);
  };
  const handleCloseNuevoItem = () => {
    getPlanActivo();
    setTimeout(() => {
      setOpenNuevoItem(false);
    }, 500);
  };
  const handleCloseEdit = () => {
    getPlanActivo();
    setTimeout(() => {
      setOpenEdit(false);
    }, 500);
  };

  return (
    <Grid container spacing={0}>
      <Grid
        item
        xs={12}
        className="center_item"
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          className="btn_system"
          sx={{ width: "fit-content", margin: "10px 30px" }}
          onClick={() => setOpenNuevo(true)}
        >
          Nueva planeación
        </Button>
      </Grid>
      <Grid
        item
        xs={12}
        className="center_item"
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <VisulizadorActivo
          key={"visualizador-activo"}
          planActivo={planActivo}
          handlePriorityChange={handlePriorityChange}
          setReorderedItems={setReorderedItems}
          reorderedItems={reorderedItems}
          updatePrioridad={updatePrioridad}
          handleOpenNuevoItemSec={handleNuevoItem}
          handleCheckboxChange={updatePrioridadIndividual}
          handleOpenEditSec={handleOpenEditSec}
        />
      </Grid>

      <ModalNuevaPlaneacion open={openNuevo} handleClose={handleClose} />
      <ModalAgregarItem
        key="modal-agregar-item"
        open={openNuevoItem}
        handleClose={handleCloseNuevoItem}
        almaSelected={newPriority}
        lastPriority={lastPriority}
      />
      <ModalEditItems
        key="modal-edit-items"
        open={openEdit}
        items={itemsEdit}
        almaSelected={almaSelectedEdit?.pp_alma_id}
        handleClose={handleCloseEdit}
        maxRacks={almaSelectedEdit?.almacenes?.alma_maxracks}
      />
    </Grid>
  );
};
